import React from 'react';
import {Container, Stack, Typography} from '@mui/material';
import ContactForm from '../components/ContactForm.js';
import {withTitle} from '../title.js';
import withMainContainer from '../components/WithMainContainer.js';

const Contact = ()=>{
    return <Container maxWidth="lg">
      <Stack direction="column" gap={3} alignItems="center">
        <Typography variant="h4">
          צור קשר
        </Typography>
        <ContactForm/>
      </Stack>
    </Container>;
};

export default withMainContainer(withTitle(`סימונה צ'רי - צור קשר`, Contact), {footerMargin: 4});
